import { IRootState } from '@/store/state';
import { Module } from 'vuex';
import { ForecastActions } from './actions';
import { ForecastGetters } from './getters';
import { ForecastMutations } from './mutations';
import { ForecastState, IForecastState } from './state';

export const ForecastModuleStore: IForecastModuleStore = {
  state: ForecastState,
  actions: ForecastActions,
  getters: ForecastGetters,
  mutations: ForecastMutations
};

/**
 * --------------------------------------------------
 *	Forecast Store Interface
 * --------------------------------------------------
 **/
export interface IForecastModuleStore
  extends Module<IForecastState, IRootState> {}
